export default __webpack_public_path__ + "static/switch-03020fc7c877eaf227d03deb3b17301a.mp3";